module.exports = __webpack_public_path__ + "img/aeroland-client-logo-06.7da61031.png";